export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc'
} as const
export type SortDirection = typeof SortDirection[keyof typeof SortDirection]
export type TableSort = { key: string; direction: SortDirection }

export const sorting = (sort: TableSort | null) => (sort?.key && sort?.direction ? `${sort.key}:${sort.direction}` : '')
